/**
 * @module tree/element
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Child
 */

import append from './append.js'

/**
 *
 * @param {Document|DocumentFragment|Element|Text} target
 * @param {String} type
 * @param {?{}} attributes
 * @param {...Child} children
 */
export default (
  target,
  type,
  attributes = {},
  ...children
) => {
  const ownerDocument = target.ownerDocument ?? target
  const element = ownerDocument.createElement(type)

  for (const [name, value] of Object.entries(attributes)) {
    element.setAttribute(name, value)
  }

  append(element, ...children)

  return element
}
